import React, { useEffect, useState } from 'react'
import './header.css'
import CTA from './CTA'
import ME from  '../../assets/me.png'
import HeaderSocial from './HeaderSocials'

const ROLES = ['Software Engineer', 'BI Developer', 'Account Manager']

const Header = () => {
  const [roleIndex, setRoleIndex] = useState(0)
  const [display, setDisplay] = useState('')
  const [deleting, setDeleting] = useState(false)

  useEffect(() => {
    const role = ROLES[roleIndex]
    let id
    if (!deleting) {
      if (display.length < role.length) {
        id = setTimeout(() => setDisplay(role.slice(0, display.length + 1)), 95)
      } else {
        id = setTimeout(() => setDeleting(true), 2200)
      }
    } else if (display.length > 0) {
      id = setTimeout(() => setDisplay(display.slice(0, -1)), 42)
    } else {
      id = setTimeout(() => {
        setDeleting(false)
        setRoleIndex((i) => (i + 1) % ROLES.length)
      }, 380)
    }
    return () => clearTimeout(id)
  }, [display, deleting, roleIndex])

  return (
   <header>
    <div className="container header_container">
      <h5 className='header_intro'>Hello I'm</h5>
      <h1 className='header_name'>Ismam Fatin Zishan</h1>
      <h5 className='text-light header_role' aria-live='polite'>
        <span className='header_typed'>{display}</span>
        <span className='header_cursor' aria-hidden='true' />
      </h5>
      <CTA/>
      
      <HeaderSocial/> 
     
     <div className="me">
      <img src={ME} alt="me" />
     </div>
     <a href='#contact' className='scroll_down'>Scroll Down</a>



    </div>
   </header>
  )
}

export default Header